export default __webpack_public_path__ + "static/logo-bbb-desktop@3x-be52107d608e40307b5e4cde25d231b6.png";